module.exports = __webpack_public_path__ + "static/media/28.c0f4b24a.JPG";